// extracted by mini-css-extract-plugin
module.exports = {"SignUpModal":"SignUpModal__3QV1_","IconWrapper":"IconWrapper__3H6Vz"};